module.exports = __webpack_public_path__ + "static/media/3364-e-l.58131471.png";